// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Seed = require("./seed");
var $$Array = require("bs-platform/lib/js/array.js");
var Theme = require("./theme");
var React = require("react");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Network = require("./network");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Plan_iconSvg = require("./assets/plan_icon.svg");
var Round_iconSvg = require("./assets/round_icon.svg");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");

var flexList = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var headBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.background(Css.hex("fffafa")),
              /* :: */[
                Css.marginBottom(Css.px(10)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.boxSizing(/* borderBox */9307263),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var infoHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(18), Css.px(0), Css.px(6), Css.px(0)),
        /* [] */0
      ]
    ]);

var infoHeaderH1 = Css.style(/* :: */[
      Css.margin4(Css.px(18), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.zIndex(2),
        /* [] */0
      ]
    ]);

var infoHeaderH4 = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(6), Css.px(0)),
        /* :: */[
          Css.zIndex(2),
          /* [] */0
        ]
      ]
    ]);

var mapElement = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var workoutContainer = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
            /* :: */[
              Css.borderTopLeftRadius(Css.px(10)),
              /* :: */[
                Css.borderTopRightRadius(Css.px(10)),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutHeaderBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.justifyContent(Css.center),
            /* :: */[
              Css.background(Css.hex("FFFAFA")),
              /* :: */[
                Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.borderTopLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderTopRightRadius(Css.px(10)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutHeaderMiddleEl = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* [] */0
      ]
    ]);

var workoutNameHeader = Css.style(/* :: */[
      Css.lineHeight(1.2),
      /* :: */[
        Css.margin4(Css.px(5), Css.px(48), Css.px(0), Css.px(48)),
        /* [] */0
      ]
    ]);

var pairBox = Css.style(/* :: */[
      Css.fontSize(Css.px(12)),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(8), Css.px(2), Css.px(8)),
        /* [] */0
      ]
    ]);

var spanEl = Css.style(/* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(10)),
        /* [] */0
      ]
    ]);

var tableHead = Css.style(/* :: */[
      Css.fontSize(Css.px(20)),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.paddingBottom(Css.px(10)),
          /* :: */[
            Css.paddingTop(Css.px(10)),
            /* [] */0
          ]
        ]
      ]
    ]);

var initialBody = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var initialBodyImg = Css.style(/* :: */[
      Css.margin4(Css.px(5), Css.px(10), Css.px(15), Css.px(10)),
      /* :: */[
        Css.padding2(Css.px(0), Css.px(0)),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* [] */0
        ]
      ]
    ]);

var tableDiv = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var horizonBox = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
          /* :: */[
            Css.justifyContent(Css.spaceAround),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.background(Css.hex("00")),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.padding2(Css.px(0), Css.px(0)),
                      /* :: */[
                        Css.height(Css.px(45)),
                        /* :: */[
                          Css.borderBottom(Css.px(1), /* solid */12956715, /* `hex */[
                                5194459,
                                "FCEBEC"
                              ]),
                          /* [] */0
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var horizonBoxEl = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.flexGrow(1),
        /* :: */[
          Css.background(Css.lightgreen),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(10), Css.px(0), Css.px(10)),
            /* :: */[
              Css.fontSize(Css.px(24)),
              /* :: */[
                Css.minHeight(Css.px(40)),
                /* :: */[
                  Css.borderLeft(Css.px(1), /* solid */12956715, /* `hex */[
                        5194459,
                        "FCEBEC"
                      ]),
                  /* :: */[
                    Css.justifyContent(Css.center),
                    /* :: */[
                      Css.alignItems(Css.center),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.marginTop(Css.px(5)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

var firstCol = Css.style(/* :: */[
      Css.justifyContent(Css.center),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.textAlign(/* center */98248149),
          /* :: */[
            Css.width(/* `percent */[
                  -119887163,
                  20.0
                ]),
            /* :: */[
              Css.color(/* `hex */[
                    5194459,
                    "FFBFC2"
                  ]),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var otherCols = Css.style(/* :: */[
      Css.alignItems(Css.center),
      /* :: */[
        Css.justifyContent(Css.center),
        /* :: */[
          Css.marginBottom(Css.px(0)),
          /* :: */[
            Css.borderLeft(Css.px(1), /* solid */12956715, /* `hex */[
                  5194459,
                  "FCEBEC"
                ]),
            /* :: */[
              Css.textAlign(/* center */98248149),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      20.0
                    ]),
                /* :: */[
                  Css.color(/* `hex */[
                        5194459,
                        "80D0D0"
                      ]),
                  /* :: */[
                    Css.fontWeight(700),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var otherColsUp = Css.style(/* :: */[
      Css.alignItems(Css.center),
      /* :: */[
        Css.justifyContent(Css.center),
        /* :: */[
          Css.marginBottom(Css.px(0)),
          /* :: */[
            Css.borderLeft(Css.px(1), /* solid */12956715, /* `hex */[
                  5194459,
                  "FCEBEC"
                ]),
            /* :: */[
              Css.textAlign(/* center */98248149),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      20.0
                    ]),
                /* :: */[
                  Css.color(/* `hex */[
                        5194459,
                        "FFBFC2"
                      ]),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var planIconBox = Css.style(/* :: */[
      Css.top(/* `percent */[
            -119887163,
            50.0
          ]),
      /* :: */[
        Css.transform(/* `translate */[
              -914368690,
              /* tuple */[
                Css.px(0),
                /* `percent */[
                  -119887163,
                  -50.0
                ]
              ]
            ]),
        /* :: */[
          Css.transform(/* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ]),
          /* :: */[
            Css.position(/* absolute */-1013592457),
            /* :: */[
              Css.left(Css.px(0)),
              /* :: */[
                Css.top(Css.px(8)),
                /* :: */[
                  Css.cursor(/* pointer */-786317123),
                  /* :: */[
                    Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var planIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var roundIcon = Css.style(/* :: */[
      Css.marginBottom(Css.px(6)),
      /* :: */[
        Css.transform(/* `scale */[
              -120664438,
              /* tuple */[
                0.5,
                0.5
              ]
            ]),
        /* [] */0
      ]
    ]);

var Styles = /* module */[
  /* flexList */flexList,
  /* headBox */headBox,
  /* contentBox */contentBox,
  /* infoHeader */infoHeader,
  /* infoHeaderH1 */infoHeaderH1,
  /* infoHeaderH4 */infoHeaderH4,
  /* mapElement */mapElement,
  /* workoutContainer */workoutContainer,
  /* workoutHeaderBox */workoutHeaderBox,
  /* workoutHeaderMiddleEl */workoutHeaderMiddleEl,
  /* workoutNameHeader */workoutNameHeader,
  /* pairBox */pairBox,
  /* spanEl */spanEl,
  /* tableHead */tableHead,
  /* initialBody */initialBody,
  /* initialBodyImg */initialBodyImg,
  /* tableDiv */tableDiv,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* inputHeader */inputHeader,
  /* firstCol */firstCol,
  /* otherCols */otherCols,
  /* otherColsUp */otherColsUp,
  /* inputField */inputField,
  /* someLink */someLink,
  /* planIconBox */planIconBox,
  /* planIcon */planIcon,
  /* roundIcon */roundIcon
];

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("Issue with int conversion in workout configuration component");
      return 2;
    } else {
      throw exn;
    }
  }
}

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("WorkoutView");

function make(week, workout, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      var currentWorkoutExercises = Seed.getWorkoutTitles(week, workout);
      var reps = Network.pullRepsConfig(/* () */0);
      var workoutId = ((Caml_int32.imul(Caml_format.caml_int_of_string(week), 6) - 6 | 0) + Caml_format.caml_int_of_string(workout) | 0) - 1 | 0;
      return React.createElement("div", {
                  className: flexList
                }, React.createElement("div", {
                      className: headBox
                    }, React.createElement("div", {
                          className: planIconBox
                        }, React.createElement("img", {
                              className: planIcon,
                              alt: "",
                              src: Plan_iconSvg
                            })), React.createElement("h1", {
                          className: infoHeaderH1
                        }, "Workout " + workout), React.createElement("h4", {
                          className: infoHeaderH4
                        }, "Woche " + (String(week) + ""))), React.createElement("div", {
                      className: contentBox
                    }, $$Array.mapi((function (index, _) {
                            return React.createElement("div", {
                                        key: String(index),
                                        className: mapElement
                                      }, React.createElement("div", {
                                            className: workoutContainer
                                          }, React.createElement("div", {
                                                className: workoutHeaderBox
                                              }, React.createElement("div", {
                                                    className: workoutHeaderMiddleEl
                                                  }, React.createElement("h4", {
                                                        className: workoutNameHeader
                                                      }, Caml_array.caml_array_get(currentWorkoutExercises, index)), React.createElement("div", {
                                                        className: pairBox
                                                      }, "Übungspaar ", Caml_array.caml_array_get(/* array */[
                                                            "1",
                                                            "1",
                                                            "2",
                                                            "2",
                                                            "3",
                                                            "3"
                                                          ], index) + "/3"))), React.createElement("div", {
                                                className: horizonBox
                                              }, React.createElement("div", {
                                                    className: firstCol
                                                  }, "Runde"), React.createElement("div", {
                                                    className: otherColsUp
                                                  }, React.createElement("img", {
                                                        className: roundIcon,
                                                        alt: "",
                                                        src: Round_iconSvg
                                                      }), "1"), React.createElement("div", {
                                                    className: otherColsUp
                                                  }, React.createElement("img", {
                                                        className: roundIcon,
                                                        alt: "",
                                                        src: Round_iconSvg
                                                      }), "2"), React.createElement("div", {
                                                    className: otherColsUp
                                                  }, React.createElement("img", {
                                                        className: roundIcon,
                                                        alt: "",
                                                        src: Round_iconSvg
                                                      }), "3"), React.createElement("div", {
                                                    className: otherColsUp
                                                  }, React.createElement("img", {
                                                        className: roundIcon,
                                                        alt: "",
                                                        src: Round_iconSvg
                                                      }), "4")), React.createElement("div", {
                                                className: horizonBox
                                              }, React.createElement("div", {
                                                    className: firstCol
                                                  }, "Wdh"), React.createElement("div", {
                                                    className: otherCols
                                                  }, String(Caml_array.caml_array_get(Caml_array.caml_array_get(Caml_array.caml_array_get(reps, workoutId), 0), index))), React.createElement("div", {
                                                    className: otherCols
                                                  }, String(Caml_array.caml_array_get(Caml_array.caml_array_get(Caml_array.caml_array_get(reps, workoutId), 1), index))), React.createElement("div", {
                                                    className: otherCols
                                                  }, String(Caml_array.caml_array_get(Caml_array.caml_array_get(Caml_array.caml_array_get(reps, workoutId), 2), index))), React.createElement("div", {
                                                    className: otherCols
                                                  }, String(Caml_array.caml_array_get(Caml_array.caml_array_get(Caml_array.caml_array_get(reps, workoutId), 3), index))))));
                          }), /* array */[
                          1,
                          1,
                          1,
                          1,
                          1,
                          1
                        ])), React.createElement("button", {
                      className: Theme.simpleButtonReset(/* () */0),
                      onClick: (function () {
                          console.log("resetting: ", workoutId);
                          Network.resetSingleCompletedWorkout(workoutId);
                          Network.resetSinglePoints(workoutId);
                          Network.resetSingleReps(workoutId);
                          return ReasonReact.Router[/* push */0]("/week/" + (week + "/workoutweek/"));
                        })
                    }, "Reset"), React.createElement("button", {
                      className: Theme.simpleButtonWhiteSpaceBelow(/* () */0),
                      onClick: (function () {
                          return ReasonReact.Router[/* push */0]("/week/" + (week + "/workoutweek/"));
                        })
                    }, "Zurück"));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.convToInt = convToInt;
exports.text = text;
exports.component = component;
exports.make = make;
/* flexList Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/workoutView.re
// module id = 146
// module chunks = 0